/*  Created by Sai for declaring Global constant variables */

/*jslint browser: true, vars: true, plusplus: true, devel: true, nomen: true, indent: 4, maxerr: 50 */
/*global $, define, require, window */
define(function (require) {
  return {
    ENGLISH_CENTRAL_APP_ID: '70215e0996306c19caa327c99c338ac2',
    GRAMMAR_TOPICS_URL: '/tools/grammer', // declares the Grammer Topic Rest url.
    GOOGLE_TRANSLATE_URL: 'https://www.googleapis.com/language/translate/v2',
    OE_SYSTEM_USER: 'SYSTEM_USER',
    LOGIN_FAILURE_ATTEMPTS_TO_SHOW_CAPTCHA: 2,
    LAST_LEVEL_NUM: 8,
    LOGIN_FAILURE_SHOW_POP_UP: 3,

    // See AccountDTO.java::AccountType
    ACCOUNT_TYPE_ENUM: {
      standard: 'STANDARD',
      twitter: 'TWITTER',
      google: 'GOOGLE',
      facebook: 'FACEBOOK',
    },

    // See State.java for valid states.
    ACCOUNT_STATE_ENUM: {
      STUDENTPAUSED: 0,
      OESUSPENDED: 1,
      OECANCELLED: 2,
      CUSTOMERCANCELLED: 3,
      SERVICECOMPLETE: 4,
      ACTIVE: 5,
      FAILEDSALE: 6,
      UNKNOWN: 7,
      TRIALCOMPLETE: 8,
      TESTIMONIALCOMPLETE: 9,
    },

    // Entries from "contenttype" table.
    CONTENT_TYPE_ENUM: {
      text: 1,
      audio: 2,
      video: 3,
      interactive: 4,
      news: 5,
      test_prep: 6,
    },

    // Entries from "contenttype" table.
    CONTENT_TYPE_NAME_ENUM: {
      text: 'Text',
      audio: 'Audio',
      video: 'Video',
      interactive: 'Interactive',
      news: 'News',
      podcast: 'Podcast',
      test_prep: 'Test Prep',
    },

    FEEDBACK_REQUEST_TYPE_ENUM: {
      ASK_A_TEACHER: 'Ask a Teacher',
      WRITING_FEEDBACK: 'Writing Feedback',
      LIVE_CLASS_FEEDBACK: 'Live Class Feedback',
      STUDENT_NOT_JOIN_CLASS: 'live.class.feedback.answer.student_never_joined',
    },

    LESSON_TYPE: {
      UnitAssessment: 'Unit Assessment',
      LiveClass: 'Live Class',
      PrivateClass: 'Private Class',
      Immersion: 'Practice',
      News: 'News',
      Idioms: 'Idioms',
      Lesson: 'Lesson',
      LevelAssessment: 'Level Assessment',
      Notification: 'Notification',
    },

    // See NotificationTypeEnum.java for valid types.
    NOTIFICATION_ENUM: {
      GENERIC: 'GenericNotification',
      GENERIC_POPUP: 'GenericPopupNotification',
      LIVE_CLASS: 'LiveClassNotification',
      PAYMENT: 'PaymentNotification',
      LEVEL_COMPLETE: 'LevelComplete',
      UNIT_COMPLETE: 'UnitComplete',
      ACCOUNT_STATUS: 'AccountStatusNotification',
      RTW: 'RequestToWorkNotification',
      RTT: 'RequestToTeachNotification',
      PLACEMENT_TEST: 'GenericPlacementTestNotification',
      DELINQUENT_ACCOUNT_STATUS: 'DelinquentAccountStatusNotification',
      LIVE_SURVEY: 'LiveClassSurveyNotification',
      GEAR_CHECK: 'GearCheckNotification',
      LIVE_CLASS_DENIED: 'LiveClassDeniedNotification',
      FEATURE_POP_UP: 'FeaturePopUpNotification',
      LEVEL_ZERO: 'LevelZeroNotification',
      TEACHER_FEEDBACK: 'TeacherFeedbackNotification',
      SUGGESTED_ACTIVITIES: 'SuggestedActivitiesNotification',
      PROFILE_COMPLETION: 'ProfileCompletionNotification',
      MID_LEVEL_TEST: 'MidLevelTestNotification',
      GAMIFICATION_NOTIFICATION: 'GamificationNotification',
      NEW_LEVEL_CONGRATULATION: 'NewLevelCongratulationNotification',

      // Following are not from NotificationTypeEnum.java but are needed for custom client code.
      ACCOUNT_STATUS_CHANGE: 'AccountStatusNotification',
      LIVE_REMINDER: 'LiveClassReminderNotification',
      LIVE_STARTING: 'LiveClassNotification',
      WELCOME_CALL: 'GenericPopupNotification',
      REMEMBER_ME_LOGOUT: 'REMEMBER_ME_LOGOUT',
    },

    PAGE_LINK_ENUM: {
      STUDY_BUNDLE: '/',
    },

    ROLE_ENUM: {
      ROLE_STUDENT: 'ROLE_USER',
    },

    // Entries from "source" table.
    SOURCE_TYPE_ENUM: {
      englishCentral: 1,
      generic: 2,
      flashLesson: 4,
      test_prep: 7,
    },

    // Entries from "status" table.
    STATUS_ENUM: {
      not_started: 'NOT STARTED',
      complete: 'COMPLETE',
      active: 'ACTIVE',
      skip: 'SKIP',
      disabled: 'DISABLED',
    },

    // Live Class Carousel Animation constants
    STUDY_BUNDLE_CAROUSEL: {
      PREV_ANIMATION: 'right',
      NEXT_ANIMATION: 'left',
      ANIMATE_IMAGE: true,
    },

    LIVE_VIDEO_SUPPORT: {
      TYPE_LOGIN: 'login',
      TYPE_ACTIVATION: 'activation',
      TYPE_FIRST_LOGIN: 'firstLogin',
      TYPE_GENERAL: 'general',
    },

    //Temporary password url parameters
    SETUP_PASSWORD_TYPE: {
      MIGRATION: 'MIGRATION',
      TOKEN: 'TOKEN',
    },

    SEARCH_VIEW: {
      IMMERSION: 'immersion',
    },

    PROFILE_SECTION: {
      INTERESTS: 'interests',
      GENERAL: 'general',
      COMMITMENT_AND_MOTIVATIONS: 'Commitment and Motivations',
    },
  };
});



//////////////////
// WEBPACK FOOTER
// ./js/common/Const.js
// module id = 87
// module chunks = 26 27 28